import { render, staticRenderFns } from "./form-autocomplete.vue?vue&type=template&id=4cb06bbf&"
import script from "./form-autocomplete.vue?vue&type=script&lang=js&"
export * from "./form-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports